/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス設備情報
 */
export interface Sgkb575aResGasEquipmentinformation {
    /** 
     * 供給地点特定番号：半角英数混在
     */
    suppntSpno?: string;
    /** 
     * エネルギー種別名称：全角文字
     */
    energyClsname?: string;
    /** 
     * 総合供給先番号：半角英数混在
     */
    sougouSupplydestinationNo?: string;
    /** 
     * 総合区分コード：半角英数混在
     */
    sougouDivcd?: string;
    /** 
     * 総合区分名称：全角文字
     */
    sougouDivaname?: string;
    /** 
     * メーター開閉栓状態フラグ：半角英数混在
     */
    meterOpenclosevalveStatusflag?: string;
    /** 
     * ガス使用状況名称：全角文字
     */
    gasUsingJokynm?: string;
    /** 
     * メーター能力：半角数値(小数点あり)
     */
    meterAbility?: number;
    /** 
     * メーター番号：半角英数混在
     */
    meterNo?: string;
    /** 
     * メーター分類コード：半角英数混在
     */
    meterBunruiCode?: string;
    /** 
     * メーター分類コード名称：全角半角混在
     */
    meterBunruiCodeaname?: string;
    /** 
     * メーター親子区分コード：半角英数混在
     */
    meterParentDivcd?: string;
    /** 
     * メーター型式：半角英数混在
     */
    metermodel?: string;
    /** 
     * メーター接続形態コード：半角英数混在
     */
    meterCnnctformCode?: string;
    /** 
     * メーター接続形態コード名称：全角半角混在
     */
    meterCnnctformCodeaname?: string;
    /** 
     * メーター有効期限：半角英数混在
     */
    meterExpirationdate?: string;
    /** 
     * センター連係有無コード：半角英数混在
     */
    centerLinkUmucode?: string;
    /** 
     * センター連係有無コード名称：全角半角混在
     */
    centerLinkumuCodeaname?: string;
    /** 
     * 供給圧力区分コード：半角英数混在
     */
    supplypressureDivcd?: string;
    /** 
     * 供給圧力区分名称：全角文字
     */
    supplypressureDivAname?: string;
    /** 
     * 業種（大分類）：半角英数混在
     */
    gyoshuLargebunrui?: string;
    /** 
     * 業種（大分類）名称：全角半角混在
     */
    gyoshuLargebunruiAname?: string;
    /** 
     * 業種（中分類）：半角英数混在
     */
    gyoshuMediumbunrui?: string;
    /** 
     * 業種（中分類）名称：全角半角混在
     */
    gyoshuMediumbunruiAname?: string;
    /** 
     * 業種（小分類）：半角英数混在
     */
    gyoshuSmallbunrui?: string;
    /** 
     * 業種（小分類）名称：全角半角混在
     */
    gyoshuSmallbunruiAname?: string;
    /** 
     * 業種コード：半角英数混在
     */
    gyoshuCode?: string;
    /** 
     * 業種名称：全角文字
     */
    gyoshuAname?: string;
    /** 
     * 閉栓時立会可否フラグ：半角英数混在
     */
    heisenjiTatiaiKahiflg?: string;
    /** 
     * 閉栓時立会可否フラグ名称：全角半角混在
     */
    heisenjiTachiaikahiFlganame?: string;
    /** 
     * 住所コード：半角英数混在
     */
    addressCode?: string;
    /** 
     * 都道府県名称：全角文字
     */
    pfcAname?: string;
    /** 
     * 行政市区名称：全角文字
     */
    administrativecitywardaname?: string;
    /** 
     * 行政町名称：全角文字
     */
    administrativetownaname?: string;
    /** 
     * 丁目名称：全角文字
     */
    chomemeisho?: string;
    /** 
     * 番地・号：全角文字
     */
    buildingnumber?: string;
    /** 
     * 建物名：全角文字
     */
    tatemono?: string;
    /** 
     * 目標：全角文字
     */
    aim?: string;
    /** 
     * 次回検針予定日：半角英数混在
     */
    jikaiKenshinPlndate?: string;
    /** 
     * 次々回検針予定日：半角英数混在
     */
    jijikaiKenshinPlndate?: string;
    /** 
     * 次々次回検針予定日：半角英数混在
     */
    jijijikaiKenshinPlndate?: string;
    /** 
     * 検針種別コード：半角英数混在
     */
    kenshinClscode?: string;
    /** 
     * 検針種別コード名称：全角半角混在
     */
    kenshinClsfyCodeaname?: string;
    /** 
     * 指定日検針日区分コード：半角英数混在
     */
    siteiKensinDiv?: string;
    /** 
     * 指定日検針日区分コード名称：全角半角混在
     */
    siteiKensinDivAname?: string;
    /** 
     * 検針日程：半角英数混在
     */
    kensinSchdl?: string;
    /** 
     * 最新区分コード：半角英数混在
     */
    latestDivcd?: string;
    /** 
     * 最新区分コード名称：全角半角混在
     */
    latestDivCodeaname?: string;
}
